import React, { useCallback } from 'react'
import { api } from '../../../services/api'
import FiltroTabelas from './components/TabelaInfoPNota'
import { HeadingPages } from '../../../components/HeadingPages'
import { Filtro } from './components/Filtro'
import { format } from 'date-fns'
import { Loader } from '../../../components/ComponentLoader/Loader'
import { Spinner } from '@chakra-ui/react'

export function ControleContabilidade() {
  const [dados, setDados] = React.useState([])
  const [loading, setLoading] = React.useState(false)
  const [loadingNotasValidadas, setLoadingNotasValidadas] = React.useState(false)
  const [notasValidadas, setNotasValidadas] = React.useState(false)

  const buscarInfoPorNota = useCallback(async (filter) => {
    setNotasValidadas(false)
    try {
      const params = {
        codigo_parceiro: filter.codParc,
        numero_pedido: filter.pedido,
        data_entrada: filter.dataDe,
        data_saida: filter.dataAte,
        pendente: filter.pendente,
        nfe: filter.nfe,
      }

      setLoading(true)

      const response = await api.post('/site/v2/categoria/listar-informacoes-conferencia-nota', params)
      var dados = []
      var data = response.data.sort((a, b) => {
        if (a.data_saida < b.data_saida) {
          return -1
        }
        if (a.data_saida > b.data_saida) {
          return 1
        }
        return 0
      })

      data.map((data) => {
        var preco_home = Math.round(parseFloat(data.valor_nota) * 100) / 100
        if (isNaN(preco_home)) {
          preco_home = 0.0
        }

        dados.push({
          ...data,
          cod_parc: data.cod_parc,
          data_pronto: data.data_pronto,
          data_saida: data.data_saida ? format(new Date(data.data_saida), 'dd/MM/yyyy HH:mm') : '',
          nome_parc: data.nome_parc,
          nome_vendedor: data.nome_vendedor,
          numero_pedido: data.numero_pedido,
          numero_unico: data.numero_nota,
          peso_total: data.peso_total,
          peso_real: data.peso_real,
          quantidades_caixa: data.quantidades_caixa,
          numero_unico_origem: data.numero_unico_origem,
          status_pendencia: data.status_pendencia,
          data_finalizacao: data.data_finalizacao,
          valor_nota: (Math.round(parseFloat(preco_home) * 100) / 100).toLocaleString('pt-br', {
            minimumFractionDigits: 2,
          }),
          existe_remessa: data.existe_remessa,
          razao_social: data.razao_social,
          transportadora: data.transportadora,
          nunota_org: data.nunota_org,
          codigo_produto: data.codigo_produto,
          sequencia: data.sequencia,
          data_emissao_nota: data.data_emissao_nota,
          nota_antecipada: data.nota_antecipada,
          link_layout: data.link_layout,
        })
      })

      const dataSemDuplicados = dados.filter((item, index, self) => {
        return index === self.findIndex((t) => t.numero_pedido === item.numero_pedido)
      })

      setDados(dataSemDuplicados)
      setLoading(false)
    } catch (error) {
      setLoading(false)
      console.log(Object.keys(error), error.message)
    }
  }, [])

  React.useEffect(() => {
    buscarInfoPorNota({
      codParc: '',
      pedido: '',
      dataDe: '',
      dataAte: '',
      pendente: '',
      nfe: '',
    })
  }, [buscarInfoPorNota])

  async function getNotasValidadas() {
    setLoadingNotasValidadas(true)
    setNotasValidadas(true)
    const response = await api.post('/site/v2/categoria/listar-informacoes-notas-validadas')

    const dados = []

    response.data.map((data) => {
      var preco_home = Math.round(parseFloat(data.valor_nota) * 100) / 100
      if (isNaN(preco_home)) {
        preco_home = 0.0
      }

      dados.push({
        ...data,
        cod_parc: data.cod_parc,
        data_pronto: data.data_pronto,
        data_saida: data.data_saida ? format(new Date(data.data_saida), 'dd/MM/yyyy') : '',
        nome_parc: data.nome_parc,
        nome_vendedor: data.nome_vendedor,
        numero_pedido: data.numero_pedido,
        numero_unico: data.numero_nota,
        peso_total: data.peso_total,
        peso_real: data.peso_real,
        quantidades_caixa: data.quantidades_caixa,
        numero_unico_origem: data.numero_unico_origem,
        status_pendencia: data.status_pendencia,
        data_finalizacao: data.data_finalizacao,
        valor_nota: (Math.round(parseFloat(preco_home) * 100) / 100).toLocaleString('pt-br', {
          minimumFractionDigits: 2,
        }),
        existe_remessa: data.existe_remessa,
        razao_social: data.razao_social,
        transportadora: data.transportadora,
        nunota_org: data.nunota_org,
        codigo_produto: data.codigo_produto,
        sequencia: data.sequencia,
        data_emissao_nota: data.data_emissao_nota,
        nota_antecipada: data.nota_antecipada,
        link_layout: data.link_layout,
        data_nfe_validada: format(new Date(data.data_nfe_validada), 'dd/MM/yyyy HH:mm'),
      })
    })

    console.log(response.data)

    setDados(dados)
    setLoadingNotasValidadas(false)
  }

  return (
    <>
      <HeadingPages name={'Validação de notas'} />
      <Filtro resultado={buscarInfoPorNota} getNotasValidadas={getNotasValidadas} />

      <FiltroTabelas
        isNotasValidadas={notasValidadas}
        view_loading_update={loading || loadingNotasValidadas}
        resultado={buscarInfoPorNota}
        dados={dados}
      />
    </>
  )
}
